import { useCssHandles } from '../../../../utils/functions';

type FilterNavigatorV3TitleProps = {
	text: string;
};
const CSS_HANDLES = ['filter__container', 'filterMessage'];
const Title = ({ text }: FilterNavigatorV3TitleProps) => {
	const { handles, withModifiers }: any = useCssHandles(`vtex-search-result-3-x-`, CSS_HANDLES);
	const filterContainer = withModifiers('filter__container', 'title');
	return (
		<div className={`${filterContainer} bb b--muted-4`}>
			<h5 className={`${handles.filterMessage}  t-heading-5 mv5 `}>{text}</h5>
		</div>
	);
};

export default Title;
